
@switch (fieldDefinition.fieldView) {
  @case (fieldViews.STORABLE_DATE) {
    <div class='info-field'>
      <span class='info-head'><strong>{{fieldDefinition.rawName ? fieldDefinition.rawName : (fieldDefinition.name | titlecase)}} :</strong></span>
      <span class='info-value'>
        <span>{{computedValue}}</span>
        @if (isSetted && fieldDefinition.getOptionParams) {
          <a
            matTooltip='Aggiungi al tuo calendario'
            target="_blank" rel="nofollow"
            color='accent' mat-button
            [href]='getHrefEventToCalendar(fieldDefinition.getOptionParams(dataContainerService, record, "save_on_google_calendar"))' >
            <mat-icon>today</mat-icon>
          </a>
        }
      </span>
    </div>
  }
  @case (fieldViews.LINK) {
    <div class='info-field info-field_link'>
      <span class='info-head'><strong>{{fieldDefinition.rawName ? fieldDefinition.rawName : (fieldDefinition.name | titlecase)}} :</strong></span>
      <a class='info-value' [href]='computedValue' target="_blank">{{computedValue}}</a>
    </div>
  }
  @case (fieldViews.CUSTOM_ICON) {
    <div class='info-field info-field_link'>
      <span class='info-head'><strong>{{fieldDefinition.rawName ? fieldDefinition.rawName : (fieldDefinition.name | titlecase)}} :</strong></span>
      <i [class]='computedValue'></i>
    </div>
  }
  @case (fieldViews.HTML) {
    <div class='info-field info-field_html'>
      <span class='info-head'><strong>{{fieldDefinition.rawName ? fieldDefinition.rawName : (fieldDefinition.name | titlecase)}} :</strong></span>
      <span class='info-value' [innerHTML]='computedValue'></span>
    </div>
  }
  @case (fieldViews.HIDDEN) {
  }
  @default {
    <div class='info-field'>
      <span class='info-head'><strong>{{fieldDefinition.rawName ? fieldDefinition.rawName : (fieldDefinition.name | titlecase)}} :</strong></span>
      @if (!loading) {
        <span class='info-value' [class.clickable-info-value]='fieldDefinition.clickOptions' (click)='onClick()' > {{computedValue}} </span>
      }
      @if (loading) {
        <span class='info-value'><mat-spinner diameter="20"></mat-spinner></span>
      }
    </div>
  }
}
